export const PRICE_PER_CREDIT = 0.12; // $0.12/credit
export const PRESETS = [50, 100, 250, 500] as const;
export const SLIDER_MIN = 50;
export const SLIDER_MAX = 500;
export const SLIDER_STEP = 5;

export type CreditPhase = "page" | "loading";

export interface BalanceData {
  addon: number;
  planUsed: number;
  planTotal: number;
}

export interface PurchaseResult {
  amount: number;
  dollars: number;
  newBalance: number;
  sessionId: string;
}

export interface PurchaseError {
  sessionId: string;
}

// Fixtures keyed by plan — used until GET /umbra/stripe/credit-balance is wired
export const MOCK_BALANCES: Record<string, BalanceData> = {
  free: { addon: 0, planUsed: 0, planTotal: 60 },
  standard: { addon: 13, planUsed: 93, planTotal: 222 },
  pro: { addon: 47, planUsed: 218, planTotal: 444 },
  proplus: { addon: 0, planUsed: 612, planTotal: 888 },
  premium: { addon: 348, planUsed: 1407, planTotal: 2222 },
};

export const fmtPrice = (n: number) => `$${n.toFixed(2)}`;
export const fmtCredits = (n: number) =>
  `${n.toLocaleString()} ${n === 1 ? "credit" : "credits"}`;

export function snapAmount(n: number): number {
  const clamped = Math.max(SLIDER_MIN, Math.min(SLIDER_MAX, n));
  return Math.round(clamped / SLIDER_STEP) * SLIDER_STEP;
}
